/**
 * ? Forgot Password Component
 */

// Dependencies
import React, { Fragment, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Form, Navbar } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

// MUI icons
import { VisibilityOff, Visibility } from "@mui/icons-material";

// Assets
import ltelogo from "./../../assets/logov1.svg";

// Axios Component
import Axios from "../../axios/Axios";

// Redux Component
import { showSnackbar } from "../redux/features/appSlice";
import { LoadingButton } from "@mui/lab";

function ForgotPassword() {
  
  // * Router Variable
  const navigate = useNavigate();

  // * Redux Variable
  const dispatch = useDispatch();

  // * State Variable
  const [passwordData, setPasswordData] = useState({
    new_password: "",
    confirm_password: "",
    role: "admin"
  });
  // console.log(passwordData);
  const [newPasswordError, setNewPasswordError] = useState({
    error: false,
    message: "",
  });
  const [confirmPasswordError, setConfirmPasswordError] = useState({
    error: false,
    message: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  // * Show Password Function
  function handleClickShowPassword() {
    setShowPassword(!showPassword);
  }

  function handleClickShowConfirmPassword () {
    setConfirmPassword(!confirmPassword);
  }
  // * Show Password Function
  function handleMouseDownPassword(event) {
    event.preventDefault();
    setShowPassword(!showPassword);
  }

  // TODO : Validate Fields
  function validatePassword() {
    let isDataValid = true;

    if (
      passwordData.new_password.length === 0 ||
      passwordData.new_password.length > 10
    ) {
      isDataValid = false;
      setNewPasswordError({
        error: true,
        message: "Password is required & must be less than 10 characters.",
      });
    }

    if (passwordData.new_password !== passwordData.confirm_password) {
      isDataValid = false;
      setConfirmPasswordError({
        error: true,
        message: "Password does not match.",
      });
    }

    return isDataValid;
  }

  // ? API Call : Post Method
  async function submitPasswordData() {
    try {
      const isValid = validatePassword();

      if (isValid) {
        setLoading(true);
        let hostURL = window.location.href;

        let firstSplit = hostURL.split("?")[1];

        let secondSplit = firstSplit.split("&")[0];

        let secondSplit_One = firstSplit.split("&")[1];

        let emailIdSplit = secondSplit.split("=")[1];

        let tokenSplit = secondSplit_One.split("=")[1];
        // console.log(firstSplit, secondSplit, tokenSplit, emailIdSplit, secondSplit_One,);

        let data = {
          email_id: emailIdSplit,
          password: passwordData.new_password,
          token: tokenSplit,
          role: passwordData.role,
        };

        const options = {
          method: "put",
          url: "/adminlogin/reset/password/resetpassword",
          auth: true,
          data: data,
        };

        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data
        );

        if (response.status === 200) {
          setLoading(false);
          setPasswordData({
            new_password: "",
            confirm_password: "",
          });
          dispatch(
            showSnackbar({
              message: "Password successfully updated !",
              severity: "success",
            })
          );
          navigate("/login");
          // window.location.reload();
        }
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      dispatch(
        showSnackbar({
          message: "Error occurred while resetting the password! Please try again later.",
          severity: "error",
        })
      );
    }
  }

  return (
    <Fragment>
      {/* Navigation Bar */}
      <Navbar className="login-admin">
        <Navbar.Brand href="#">
          <div class="navbar-brand">
            <img className="ltelogo" src={ltelogo} alt="Logo" />
            <span className="login-admin-title">Lets Teach English</span>
          </div>
        </Navbar.Brand>
      </Navbar>

      {/* Page Content */}
      <Box
        sx={{
          width: "600px",
          m: "150px auto",
          padding: "24px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          boxShadow:
            "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
          borderRadius: "10px",
          opacity: 1,
        }}
      >
        {/* Title */}
        <Box>
          <Typography variant="h6" component="div" gutterBottom>
            Reset Password
          </Typography>
        </Box>

        {/* Input Field */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            mt: "16px",
          }}
        >
          <Box>
            <Typography variant="p" component="div" sx={{ mb: "8px" }}>
              New Password
            </Typography>

            <TextField
              type={showPassword ? "text" : "password"}
              id="newPassword"
              size="small"
              variant="outlined"
              label="Password"
              placeholder="********"
              sx={{ width: 500 }}
              value={passwordData.new_password}
              onChange={(e) => {
                setNewPasswordError({
                  ...newPasswordError,
                  error: false,
                  message: "",
                });
                setPasswordData({
                  ...passwordData,
                  new_password: e.target.value,
                });
              }}
              error={newPasswordError.error}
              helperText={
                newPasswordError.error ? newPasswordError.message : ""
              }
              InputProps={{
                autoComplete: "off",
                endAdornment: (
                  <InputAdornment>
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {showPassword ? (
                        <Tooltip title="Hide Password" arrow placement="right">
                          <Visibility />
                        </Tooltip>
                      ) : (
                        <Tooltip title="Show Password" arrow placement="right">
                          <VisibilityOff />
                        </Tooltip>
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>

          <Box sx={{ mt: "8px", mb: "8px" }}>
            <Typography variant="p" component="div" sx={{ mb: "8px" }}>
              Confirm Password
            </Typography>

            <TextField
              type={confirmPassword ? "text" : "password"}
              id="confirmPassword"
              variant="outlined"
              size="small"
              label="Confirm Password"
              placeholder="********"
              sx={{ width: 500 }}
              // InputProps={{
              //   autoComplete: "off",
              // }}
              value={passwordData.confirm_password}
              onChange={(e) => {
                setConfirmPasswordError({
                  error: false,
                  message: "",
                });
                setPasswordData({
                  ...passwordData,
                  confirm_password: e.target.value,
                });
              }}
              error={confirmPasswordError.error}
              helperText={
                confirmPasswordError.error ? confirmPasswordError.message : ""
              }
              InputProps={{
                autoComplete: "off",
                endAdornment: (
                  <InputAdornment>
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowConfirmPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {confirmPassword ? (
                        <Tooltip title="Hide Password" arrow placement="right">
                          <Visibility />
                        </Tooltip>
                      ) : (
                        <Tooltip title="Show Password" arrow placement="right">
                          <VisibilityOff />
                        </Tooltip>
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          <Form>
                  <Form.Check
                    type="checkbox"
                    id="spoc"
                    label="Change new password in Spoc"
                    value="spoc"
                  onChange={(e)=>{
                    e.target.checked ? 
                    setPasswordData({
                      ...passwordData,
                      role: "spoc",
                    }) :
                    setPasswordData({
                      ...passwordData,
                      role: "admin",
                    })
                  }}
                  />
                </Form>
        </Box>

        {/* Button */}
        <Box sx={{ mt: "16px", mb: "16px" }}>
          <LoadingButton
            loading={loading}
            type="submit"
            variant="contained"
            color="primary"
            sx={{ backgroundColor: "#1D3FAA", color: "#fff" }}
            onClick={submitPasswordData}
          >
            submit
          </LoadingButton>
        </Box>
      </Box>
    </Fragment>
  );
}

export default ForgotPassword;
